import { produce } from "immer";
import { CardSizeEnum } from "../../enums/table/card-size.enum";
import { TableModeEnum } from "../../enums/table/table-mode-enum";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../list-features/list-featues.reducers";
import { ITableDefinitionState } from "./interfaces/table-definition-state";
import { ITableState } from "./interfaces/table-state";
import { TablesState } from "./interfaces/tables-state";

export const initializeTableHandler = function (state: TablesState, tableId: string, definitions: ITableDefinitionState[]) {
    return {
        ...state,
        [tableId]: {
            filters: [],
            filterSets: state[tableId]?.filterSets ?? [],
            pagination: {
                page: DEFAULT_PAGE,
                pageSize: DEFAULT_PAGE_SIZE
            },
            definitions: definitions,
            defaultDefinitions: definitions,
            defaultSortKey: definitions.find(d => d.sortDirection != null)?.key ?? null,
            defaultSortDirection: definitions.find(d => d.sortDirection != null)?.sortDirection ?? null,
            selection: {
                selectedItems : [],
                deSelectedItems: [],
                isAllSelected : false,
                multipleItemsSelected: false,
                selectAllPristine: false
            }
        }
        
    };
}

export const setIsTableLoadingStateHandler = function (state: TablesState, tableId: string, isTableLoading: boolean ) {

    const nextState = produce(state[tableId], draft => {
        draft.isLoadingTableData = isTableLoading;
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}

export const setTableModeStateHandler = function (state: TablesState, tableId: string, mode: TableModeEnum ) {
    const nextState = produce(state[tableId], draft => {
        draft.tableMode = mode;
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}

export const setCardSizeStateHandler = function (state: TablesState, tableId: string, size: CardSizeEnum ) {
    const nextState = produce(state[tableId], draft => {
        draft.cardSize = size;
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}

export const overrideStateHandler = function (state: TablesState, tableId: string, newState : ITableState) {

    const nextState = produce(newState, draft => {
        draft.overrided = true;
    })

    return {
        ...state,
        [tableId]: nextState
    }
}

export const removeTableStateHandler = function (state: TablesState, tableId: string ) {

    let oldstate = { ...state }

    const newState = produce(oldstate, draft => {
      delete draft[tableId]
    });

    return {
        ...state,
      ...newState
    };
}

export const setOverrideTableStateHandler = function (state: TablesState, tableId: string, override : boolean ) {

    const nextState = produce(state[tableId], draft => {
        draft.overrided = override;
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}

export const setSlideInStateHandler = function (state: TablesState, tableId: string, active : boolean ) {

    // A details overlay can be opened away from its table page (e.g. from the dashboard), where
    // the table's state slice was never initialized - then there is simply no slide-in flag to
    // maintain. Producing on undefined crashed on close ("Cannot set properties of undefined").
    if (state[tableId] == undefined) return state;

    const nextState = produce(state[tableId], draft => {
        draft.isSlideInActive = active;
    })

    return {
        ...state,
        [tableId]: {...nextState}
    }
}
